// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createActionsHook, createHook } from '@atlassian/react-sweet-state';
import Store from '../store.tsx';

export const useSpaState = createHook(Store);

export const useSpaStateActions = createActionsHook(Store);
